import React from "react"
import { connect } from "react-redux"
import styled from "@emotion/styled"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { queries } from  "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

import { setCurrentSection } from "../../actions"
import { clearSessionStorage } from "../../utils/general"

const mageProtocol = process.env.GATSBY_MAGENTO_API_PROTOCOL
const mageURL = process.env.GATSBY_MAGENTO_API_URL

const FakeLink = styled.button`
  border-bottom: 1px solid ${theme.wild.color.master.base.black};
  font-size: 12px;
  line-height: 12px;
  height: 14px;
  ${queries.medium`
    font-size: 14px;
    line-height: 14px;
    height: 17px;
  `}
  ${queries.large`
    font-size: 16px;
    line-height: 20px;
    height: 21px;
  `}
`
const XWrap = styled.span`
  display: inline-block;
  font-size: 14px;
  line-height: 12px !important;
  transform: rotate(45deg);
  margin-left: 6px;
  ${queries.medium`
    font-size: 16px !important;
    line-height: 16px !important;
  `}
`
const TextWrap = styled.span`
  display: inline-block;
  color: ${theme.wild.color.master.secondary.default};
  margin-right: 3px;
`

const SaveAndExitButton = props => {

  const clearStateSetLocation = () => {

    if (window.location.pathname.indexOf("results") > -1) {
      segmentEvent('Quiz Clicked Exit', {
        "quiz_version": process.env.GATSBY_QUIZ_VERSION,
        "section_name": 'results',
        "token": props.token,
      })
    } else {
      /*
       * getting the current Q id and text from JSON + sessionStorage
       * let sectionNum = sectionNameToNum(props.currentSection)
       * let quizProgress = sessionStorage.getItem("quizProgress") ? parseInt(sessionStorage.getItem("quizProgress")) : 0
       * let sectionJson = quizJson?.[sectionNum] ? quizJson[sectionNum] : quizJson?.sections?.[sectionNum] ? quizJson.sections[sectionNum] : ""
       * let currentQuestionJson = sectionJson?.questions?.[quizProgress] ? sectionJson.questions[quizProgress] : sectionJson[quizProgress]
       * let currentQuestionText = currentQuestionJson?.text ? currentQuestionJson.text : ""
       * let currentQuestionId = currentQuestionJson?.id ? currentQuestionJson.id : ""
       * segmentEvent('Quiz Clicked Exit', {
       *   "question": currentQuestionText,
       *   "question_id": currentQuestionId,
       *   "quiz_version": process.env.GATSBY_QUIZ_VERSION,
       *   "section_name": props.currentSection,
       *   "token": props.token,
       * })
       */
    }

    // clear all values so they are clean next visit
    if (typeof window !== `undefined`) {
      clearSessionStorage() 
      let linkDestination = mageProtocol + "://" + mageURL + "/men/"
      setTimeout(() => {
        window.location = linkDestination
      }, 250)
    }

  }

  return (
    <FakeLink onClick={() => clearStateSetLocation()}>
      <TextWrap className="font-dinamoRegular text-master-secondary-default">{`Exit Quiz`}</TextWrap>
      <XWrap>{`+`}</XWrap>
    </FakeLink>
  )
}

const mapStateToProps = state => {
  return {
    quizProgress: state.progressReducer.quizProgress,
    currentSection: state.sectionReducer.currentSection,
    token: state.tokenReducer.token,
    currentQuestionId: state.questionIdReducer.currentQuestionId,
  }
}

export default connect(mapStateToProps, { setCurrentSection })(SaveAndExitButton)